import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import viCommon from './locales/vi/common.json';
import viNavigation from './locales/vi/navigation.json';
import viAuth from './locales/vi/auth.json';
import viValidation from './locales/vi/validation.json';
import viFiles from './locales/vi/files.json';
import viPatient from './locales/vi/patient.json';
import viAppointment from './locales/vi/appointment.json';
import viReports from './locales/vi/reports.json';
import viSettings from './locales/vi/settings.json';
import viTreatment from './locales/vi/treatment.json';
import viAttendance from './locales/vi/attendance.json';
import viOvertime from './locales/vi/overtime.json';
import viWorkTimesheet from './locales/vi/workTimesheet.json';
import viAudit from './locales/vi/audit.json';
import viClinic from './locales/vi/clinic.json';
import viExpense from './locales/vi/expense.json';
import viIncome from './locales/vi/income.json';
import viFinance from './locales/vi/finance.json';
import viPayment from './locales/vi/payment.json';
import viIdentity from './locales/vi/identity.json';
import viInventory from './locales/vi/inventory.json';
import viLabo from './locales/vi/labo.json';
import viPrescription from './locales/vi/prescription.json';
import viScheduling from './locales/vi/scheduling.json';
import viNotification from './locales/vi/notification.json';
import viPlatform from './locales/vi/platform.json';
import viPrint from './locales/vi/print.json';
import viPromotion from './locales/vi/promotion.json';
import viCommission from './locales/vi/commission.json';
import viReferralCommission from './locales/vi/referralCommission.json';
import viStaff from './locales/vi/staff.json';
import viTask from './locales/vi/task.json';
import viComment from './locales/vi/comment.json';
import viProject from './locales/vi/project.json';
import viKpi from './locales/vi/kpi.json';
import viPayroll from './locales/vi/payroll.json';
import viLead from './locales/vi/lead.json';
import viMessaging from './locales/vi/messaging.json';
import viInternalChat from './locales/vi/internalChat.json';
import viWallet from './locales/vi/wallet.json';
import viDiagnosis from './locales/vi/diagnosis.json';
import viCalls from './locales/vi/calls.json';

export const defaultNS = 'common';

export const resources = {
  vi: {
    common: viCommon,
    navigation: viNavigation,
    auth: viAuth,
    validation: viValidation,
    files: viFiles,
    patient: viPatient,
    appointment: viAppointment,
    reports: viReports,
    settings: viSettings,
    treatment: viTreatment,
    attendance: viAttendance,
    overtime: viOvertime,
    workTimesheet: viWorkTimesheet,
    audit: viAudit,
    clinic: viClinic,
    expense: viExpense,
    income: viIncome,
    finance: viFinance,
    payment: viPayment,
    identity: viIdentity,
    inventory: viInventory,
    labo: viLabo,
    prescription: viPrescription,
    scheduling: viScheduling,
    notification: viNotification,
    platform: viPlatform,
    print: viPrint,
    promotion: viPromotion,
    commission: viCommission,
    referralCommission: viReferralCommission,
    staff: viStaff,
    task: viTask,
    comment: viComment,
    project: viProject,
    kpi: viKpi,
    payroll: viPayroll,
    lead: viLead,
    messaging: viMessaging,
    internalChat: viInternalChat,
    wallet: viWallet,
    diagnosis: viDiagnosis,
    calls: viCalls,
  },
} as const;

export const namespaces = [
  'common',
  'navigation',
  'auth',
  'validation',
  'files',
  'patient',
  'appointment',
  'reports',
  'settings',
  'treatment',
  'attendance',
  'overtime',
  'workTimesheet',
  'audit',
  'clinic',
  'expense',
  'income',
  'finance',
  'payment',
  'identity',
  'inventory',
  'labo',
  'prescription',
  'scheduling',
  'notification',
  'platform',
  'print',
  'promotion',
  'commission',
  'referralCommission',
  'staff',
  'task',
  'comment',
  'project',
  'kpi',
  'payroll',
  'lead',
  'messaging',
  'internalChat',
  'wallet',
  'diagnosis',
  'calls',
] as const;

i18n.use(initReactI18next).init({
  resources,
  lng: 'vi',
  fallbackLng: 'vi',
  defaultNS,
  ns: [...namespaces],
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
});

export default i18n;
